import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

import Button from "@/components/button.vue"
  import Option from "@/components/inputs/option.vue"
  import ContentModal from "@/components/modals/content.vue"
  import TextInput from "@/components/inputs/text.vue"
  import {ref} from "vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'enumeration',
  props: /*@__PURE__*/_mergeModels({
    options: {
      default: null,
      required: true,
      type: Array<string>
    },
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    },
    title: {
      default: null,
      required: false,
      type: String
    }
  }, {
    "selection": {
    default: null,
    required: true,
    type: String
  },
    "selectionModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["update"], ["update:selection"]),
  setup(__props, { emit: __emit }) {

  

  const emits = __emit
  const selection = _useModel(__props, "selection")
  
  const display = ref<boolean>(false)

  function update() {
    display.value = false
    emits("update")
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createVNode(TextInput, {
        value: selection.value,
        title: __props.title,
        readOnly: __props.readOnly,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (display.value = true))
      }, null, 8, ["value", "title", "readOnly"]),
      (display.value)
        ? (_openBlock(), _createBlock(ContentModal, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(Option, {
                selection: selection.value,
                "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => ((selection).value = $event)),
                options: __props.options,
                readOnly: __props.readOnly,
                onUpdate: _cache[2] || (_cache[2] = ($event: any) => (update()))
              }, null, 8, ["selection", "options", "readOnly"]),
              _createVNode(Button, {
                title: "Close",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (display.value = false))
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})